module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"sc-status-widget:total":"Всего"},"en":{"sc-status-widget:total":"Total"}}')
  delete Component.options._Ctor
}
